import React, { useEffect } from 'react';
import './fridgeservice.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import FriDesc1 from '../images/fridgedec1.jpg';
import FriDesc2 from '../images/fridgedec2.jpg';
import FriDesc3 from '../images/fridgedesc3.png';
import Fridgegal1 from '../images/fridgegal1.jpg'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillWave, faWrench, faTachometerAlt, faHome } from '@fortawesome/free-solid-svg-icons';












export default function FridgeService() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <div>
    <div><Navbar /></div>
    <div>
      <section id="hero" style={{ backgroundImage: `url(${Fridgegal1})` }}>
        <div className="hero-content">
          <h1>FRIDGE SERVICE CENTER</h1>
          <p>Your Trusted Solution for All Appliance Repairs</p>
          <a href="tel:+919176849803" className="hero-btn">Book Service?</a>
        </div>
      </section>

      <section id="About">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
              <h2>About</h2>
              <p>Welcome to Sri Hari Home Care! With over six years of dedicated service in the industry, we are proud to be your trusted partner for refrigerator repairs. We understand how essential a properly working fridge is to your daily life, preserving your food and keeping your household running smoothly. Our expert team is here to ensure your fridge performs at its best.

At Sri Hari Home Care, transparency is at the core of our service. We know that trust is the foundation of our relationship with you, which is why we keep you informed every step of the repair process. Our skilled technicians provide high-quality service, clearly explaining the costs and methods involved in restoring your refrigerator.

Customer satisfaction is our top priority. We are committed to offering timely, dependable service, so you can count on us whenever your fridge needs attention. Whether it’s a minor fix or a major repair, our team is ready to help you get your refrigerator back to peak performance.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={FriDesc1} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>High Quality Service</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>At Sri Hari Home Care, we specialize in reliable fridge repair and maintenance services to keep your appliance operating efficiently. Our skilled technicians are experienced in handling all brands and types of refrigerators, from single-door to double-door and multi-door models. We use only genuine parts for repairs, ensuring long-lasting performance and reliability. With over six years of trusted service, Sri Hari Home Care is committed to transparency in pricing and process, giving peace of mind to every customer. Our goal is to provide quick, high-quality service that you can rely on, helping you maintain your fridge’s performance without disruption.</p>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={FriDesc2} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Affordable Service</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Sri Hari Home Care offers affordable fridge repair and maintenance services, ensuring your appliance remains in excellent working condition without breaking the bank. Our team of experienced technicians is well-trained to handle all types of refrigerators, from single-door to double-door and multi-door models, across various brands. With a commitment to transparency and trust built over six years, Sri Hari Home Care provides accurate diagnostics, quality repairs, and genuine spare parts to enhance the lifespan of your fridge. We prioritize timely and effective service to help prevent food spoilage, allowing you to enjoy a smoothly running refrigerator year-round at prices you can afford.</p>
    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={FriDesc3} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Best Service Center</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Sri Hari Home Care is the best fridge service center, providing expert repair and maintenance services to keep your refrigerator in optimal condition. Our skilled technicians are trained to handle all types of refrigerators—whether single-door, double-door, or multi-door models—across various brands. With six years of trusted experience, we prioritize transparency in our services, offering clear pricing and reliable solutions for all your refrigeration needs. We utilize genuine parts and advanced tools to ensure efficient repairs, enhancing your fridge’s performance and energy efficiency. Count on us for fast and dependable service, ensuring your refrigerator runs smoothly and effectively throughout the year.</p>
    </div>
  </div>
</section>





<section class="what-we-do">
  <div class="container">
    <h2>What We Do</h2>
    <p>At <strong>Sri Hari Home Care</strong>, we have been serving Chennai with pride for over <strong>6+ years</strong>, providing reliable and professional appliance repair services for washing machines, refrigerators, and air conditioners.</p>
    
    <div class="service-process">
      <div class="step">
        <h3>1. Easy Access</h3>
        <p>Our website is equipped with Google Ads, making it easy for customers to find us when they search for appliance repair services. With a quick phone call from our website, customers are instantly connected to our support team.</p>
      </div>
      <div class="step">
        <h3>2. Efficient Complaint Registration</h3>
        <p>Our customer support team registers the complaint and forwards it to a trained technician. Our team is committed to fast response times and customer satisfaction.</p>
      </div>
      <div class="step">
        <h3>3. Technician Appointment</h3>
        <p>Our technician contacts the customer to set up an appointment. We respect your time, arriving punctually and working efficiently.</p>
      </div>
      <div class="step">
        <h3>4. Quick and Reliable Repair</h3>
        <p>Upon arrival, our technician assesses the issue and repairs it within <strong>3-4 hours</strong>. If any spare parts need replacement, the technician shows the customer the faulty part and explains the need for a new one.</p>
      </div>
      <div class="step">
        <h3>5. Transparent and Fair Pricing</h3>
        <p>We charge a service fee of <strong>₹400</strong>. If any spare parts are replaced, they are charged at market rates, ensuring quality and transparency. All parts are opened in front of the customer for full confidence.</p>
      </div>
    </div>
  </div>
</section>



<section class="fridge-issues-section">
  <h2 class="section-heading">Issues in Fridge</h2>
  <div class="issues-container">
    
    <div class="issue-card">
      <i class="fas fa-tint icon"></i>
      <h3 class="issue-title">Water Leakage</h3>   
      <p class="issue-description">Water leakage could be caused by clogged defrost drains or a damaged water filter. Timely repairs are essential to avoid water damage.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-cogs icon"></i>
      <h3 class="issue-title">Not Cooling</h3>
      <p class="issue-description">If the fridge isn't cooling, it might be due to a refrigerant leak or compressor failure. Immediate attention is needed to avoid food spoilage.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-exclamation-triangle icon"></i>
      <h3 class="issue-title">Noisy Operation</h3>
      <p class="issue-description">Strange noises could indicate an issue with the fan motor or condenser. This needs professional inspection to prevent further damage.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-plug icon"></i>
      <h3 class="issue-title">Power Issues</h3>
      <p class="issue-description">Power issues may stem from the control board or electrical supply. A technician can diagnose and repair the issue safely.</p>
    </div>

    <div class="issue-card">
      <i class="fas fa-thermometer-half icon"></i>
      <h3 class="issue-title">Temperature Fluctuations</h3>
      <p class="issue-description">If the fridge is experiencing temperature fluctuations, the thermostat or evaporator coils may be malfunctioning. Professional repair is recommended.</p>
    </div>

  </div>
</section>












      <section id="tech-spec" class="tech-special-section">
  <h2 class="section-title">Our Tech-Special</h2>
  <div class="tech-features-container">
      
      <div class="tech-feature">
          <i class="fas fa-cogs icon"></i>
          <h3>Work Performance</h3>
          <p>Our team delivers top-notch performance on every job, ensuring your appliances are handled with expert care and precision.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-clock icon"></i>
          <h3>Punctuality</h3>
          <p>We respect your time. Our technicians arrive on schedule and complete tasks within the estimated time frame.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-bolt icon"></i>
          <h3>Speed of Work</h3>
          <p>Efficiency is key. We complete repairs and maintenance swiftly without compromising on quality.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-headset icon"></i>
          <h3>Quick Response</h3>
          <p>Our customer service team is quick to respond to inquiries and schedule appointments with minimal delay.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-user-friends icon"></i>
          <h3>Friendly Technicians</h3>
          <p>Our technicians are not only skilled but also friendly and courteous, ensuring a positive service experience.</p>
      </div>

      <div class="tech-feature">
          <i class="fas fa-broom icon"></i>
          <h3>Neat & Clean Work</h3>
          <p>We leave no mess behind. Our technicians ensure that your space is as clean as it was before the service.</p>
      </div>

  </div>
</section>



<section class="testimonials">
  <h2 class="section-title" id="testihead">Customer Testimonials</h2>
  <div class="testimonial-container">
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Our fridge service was excellent! Very reliable and on time."</p>
          <p class="customer-name">- Kumar</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Professional fridge repair service. My refrigerator is cooling perfectly now."</p>
          <p class="customer-name">- Saravanan</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Quick and efficient repair service for our fridge. Highly recommend!"</p>
          <p class="customer-name">- Augustin</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"The technician was very knowledgeable. My fridge works like new now!"</p>
          <p class="customer-name">- Ramu</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Great service! My fridge has been running smoothly since the repair."</p>
          <p class="customer-name">- Murugan</p>
      </div>
      <div class="testimonial-card">
          <div class="stars">
              ★★★★★
          </div>
          <p class="testimonial-text">"Reliable and affordable fridge repair. Very satisfied with the service!"</p>
          <p class="customer-name">- Ganesh</p>
      </div>
  </div>
</section>







      <section id="features" className="container my-5">
        <div className="row text-center">
          <div className="col-md-6 mb-4">
            <div className="feature-box d-flex align-items-center">
              <FontAwesomeIcon icon={faMoneyBillWave} className="icon-rosy-red" />
              <div className="feature-text ms-3">
                <h4>No Initial Payment</h4>
                <p>Enjoy peace of mind with our service-first policy. Pay only once the job is done to your satisfaction—no upfront costs!</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="feature-box d-flex align-items-center">
              <FontAwesomeIcon icon={faWrench} className="icon-rosy-red" />
              <div className="feature-text ms-3">
                <h4>Original Spare Parts</h4>
                <p>We use only genuine spare parts for repairs, ensuring high performance and durability for your appliances.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="feature-box d-flex align-items-center">
              <FontAwesomeIcon icon={faTachometerAlt} className="icon-rosy-red" />
              <div className="feature-text ms-3">
                <h4>Speed Service</h4>
                <p>Our team is dedicated to fast, efficient service to minimize your appliance downtime and get you back on track.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="feature-box d-flex align-items-center">
              <FontAwesomeIcon icon={faHome} className="icon-rosy-red" />
              <div className="feature-text ms-3">
                <h4>Doorstep Service</h4>
                <p>Experience the convenience of professional appliance repair at your doorstep, saving you time and effort.</p>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section class="opening-hours">
  <h2 class="section-title" id="Openhead">Opening Hours</h2>
  <div class="hours-container">
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Monday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Tuesday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Wednesday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Thursday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Friday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day">
          <i class="day-icon fas fa-calendar-day"></i>
          <span>Saturday</span>
          <span>9:00 AM - 7:00 PM</span>
      </div>
      <div class="day closed">
          <i class="day-icon fas fa-calendar-times"></i>
          <span>Sunday</span>
          <span>Closed</span>
      </div>
  </div>
</section>



<section id="support-section">
    <h2 class="support-title">Customer Support</h2>
    <div class="support-container">
        <div class="support-row">
            <div class="support-card">
                <div class="support-icon">
                    <i class="fas fa-phone-alt"></i>
                </div>
                <h4>Tele-calling Team</h4>
                <p>
                    Our dedicated tele-calling team is always ready to assist you with inquiries, ensuring quick responses and personalized support.
                </p>
            </div>
            <div class="support-card">
                <div class="support-icon">
                    <i class="fas fa-headset"></i>
                </div>
                <h4>24X7 Customer Support</h4>
                <p>
                    Our customer support is available 24/7, ready to help you with any issues or questions you may have at any time of day or night.
                </p>
            </div>
            <div class="support-card">
                <div class="support-icon">
                    <i class="fas fa-tools"></i>
                </div>
                <h4>Technician Arranging Incharge Team</h4>
                <p>
                    Our expert technician arranging incharge team ensures that the right professionals are dispatched to your location quickly and efficiently.
                </p>
            </div>
        </div>
    </div>
</section>


    <section id="faq-section" class="faq-section">
    <div class="container">
        <h2 class="section-title">FAQ for Fridge Service</h2>

        <div class="faq-card">
            <h4 class="faq-question">Why is my fridge not cooling properly?</h4>
            <p class="faq-answer">
                Poor cooling can be caused by a dirty condenser coil, a malfunctioning thermostat, or insufficient refrigerant levels. It's advisable to call a technician to inspect the fridge.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">What causes a fridge to make a loud noise?</h4>
            <p class="faq-answer">
                A loud noise may be due to a malfunctioning compressor, a loose fan, or ice buildup in the evaporator. Professional inspection can help identify the root cause.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">How do I prevent my fridge from freezing the food?</h4>
            <p class="faq-answer">
                Freezing food in the fridge can be caused by incorrect temperature settings, malfunctioning thermostats, or damaged door seals. Ensure the temperature is set correctly and check for leaks.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">Why is there water pooling in my fridge?</h4>
            <p class="faq-answer">
                Water pooling can happen due to clogged defrost drains, a faulty door seal, or incorrect temperature settings. Inspecting the drain or seal is recommended.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">What should I do if my fridge smells bad?</h4>
            <p class="faq-answer">
                Bad odors are often caused by spoiled food or mold in the fridge. Clean the fridge thoroughly and use an odor-absorbing agent to keep it fresh.
            </p>
        </div>

        <div class="faq-card">
            <h4 class="faq-question">How often should I clean the coils of my fridge?</h4>
            <p class="faq-answer">
                Cleaning the condenser coils every 6 months helps improve efficiency and prolongs the life of your fridge. It's important to do this regularly to prevent overheating.
            </p>
        </div>
    </div>
</section>

<section id="disclaimer" class="disclaimer-section">
    <div class="disclaimer-content">
        <h2 class="disclaimer-title">Disclaimer</h2>
        <p class="disclaimer-text">
          Sri Hari Home Care is not authorized by any specific brand. We are a multibrand service provider offering assistance for a variety of home appliances.
        </p>
    </div>
</section>
    </div>
    <div><Footer /></div>
  </div>
  )
}
